export default "__VITE_ASSET__DogFRHmu__"